import Header from 'components/header'
import SideBar from 'components/siderbar'
import { NotificationContext } from 'context/notification_context'
import React, { useContext, useEffect, useRef, useState } from 'react'
import Renderif from 'utils/renderif'
import { Button, ListGroup } from 'react-bootstrap'
import { MdDelete, MdEdit } from 'react-icons/md'
import { useNavigate } from 'react-router'
import { Service } from 'services/api'

export default function RewardsView() {
  const navigate = useNavigate()
  const [file, setFile] = useState(null)
  const {notify} = useContext(NotificationContext)
  const image = useRef();
  const [state, setState] = useState({
    reward:{
      name:"",
      image:""
    },
    rewards:[],
    editing:false
  })



  useEffect(()=>{
    init();
    return () => {}
  },[])

  const init = async () => {
    let _rewards = await Service('GET', 'reward')
    console.log(_rewards)
    state.rewards = _rewards.data.data;
    setState({...state})
  }
  const upLoad = async () => {
        
    let body = new FormData();
    body.append("file", file);
    return await Service('POSTMEDIA', `upload`, body )
 
  } 
  const onCreateReward = async () => {

       
        let body = {
            ...state.reward,
            uid:null,
            type:null,
            stock:null,
            idSponsor:null

        }

        if(file !== null){
            let _upload = await upLoad()
            body.image = _upload.data;
        }



        console.log(body)

        let _create_reward = await Service('POST', `reward`, body)
        if(_create_reward.status === 201){
            notify({title:"Recompensas", message:"Recompensa creada exitosamente.", type:'success'})
            setFile(null)
            image.current.value = "";
            state.reward = {name:"", image:""}
            init()
            // navigate(`/answer/${id_activity}/${_create_question.data.data.id}`)
        }

  }
  const onUpdateReward = async (id) => {

            let body = {
            ...state.reward,
            uid:null,
            type:null,
            stock:null,
            idSponsor:null

        }

        if(file !== null){
            let _upload = await upLoad()
            body.image = _upload.data;
        }



    

        let _create_reward = await Service('PATCH', `reward/${id}`, body)
        if(_create_reward.status === 200){
            notify({title:"Recompensas", message:"Recompensa editada exitosamente.", type:'success'})
            setFile(null)
            state.editing = false;
            image.current.value = "";
            state.reward = {name:"", image:""}
            init()
            // navigate(`/answer/${id_activity}/${_create_question.data.data.id}`)
        }

  }
  const onDeleteReward = async (id) => {
    let _delete = await Service('DELETE', `reward/${id}`)
    if(_delete.status === 200){
        notify({title:"Recompensas", message:"Recompensa eliminada exitosamente.", type:'success'})
        init()
    }
  }



  return (
    <div className='container-fluid d-flex p-0'>

    <SideBar></SideBar>

    <div className='col overflow-auto bg-primary'>

        
         <Header title="Recompensas" subtitle="Yelmo" />

         <div className='container-md mt-3'>
           <div className='bg-white-alpha-05 r-10 p-3'>

            <div className=''>
                <div className='f-14 bold my-1'>Nombre</div>
                <input type='text' className='form-control' value={state.reward.name} onChange={(evt)=>{
                    
                    state.reward.name = evt.currentTarget.value
                    setState({...state})
                }}></input>
            </div>


            <div>
                <div className='f-14 bold my-1'>Imagen</div>
                <input type='file' ref={image} className='form-control' onChange={(evt)=>{
                    console.log(evt.currentTarget.files[0])
                    setFile(evt.currentTarget.files[0])
                    
                }}></input>

                <Renderif isTrue={state.reward.image !== "" && state.reward !== null}>
                    <img className='mt-1 rounded-2' width={168} src={file !== null ? URL.createObjectURL(file) : state.reward.image}></img>
                </Renderif>

                {/* <Renderif isTrue={file !== null}>
                    <img className='mt-1 rounded-2' width={168} src={URL.createObjectURL(file)}></img>
                </Renderif> */}
            </div> 

            <div className='mt-3'>
                <Button variant="primary" onClick={() => {
                  if(state.editing){
                    onUpdateReward(state.reward.id)
                  }else{
                    onCreateReward()
                  }
                    // setState({...state, step:1})
                }}>

                    {state.editing ? 'Guardar' : '+ Recompensa'}
                </Button>

                <Renderif isTrue={state.editing}>
                  <Button variant="danger" className='ms-1' style={{border:'none'}} onClick={() => {
                      state.editing = false;
                      state.reward = {name:"", image:""}
                      setFile(null)
                      image.current.value = "";
                      setState({...state})
                  }}>
                      Cancelar
                  </Button>
                </Renderif>
             
            </div>

   

            <table className='table mt-3 r-5 overflow-hidden'>
                    <thead>
                        <tr>
                            <th><div className='f-14 bold'>Imagen</div></th>
                            <th><div className='f-14 bold'>Nombre</div></th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {state.rewards.map((reward, i)=>{
                            return (
                                <tr className=''>
                                    <td>
                                        <Renderif isTrue={reward.image !== "" && reward.image !== null}>
                                            <img alt='' width={40} src={reward.image}></img>
                                        </Renderif>
                                    </td>
                                    <td>{reward.name}</td>
                                    <td>
                                      <div className='d-flex'>

                                        <div className='icon mx-3 cursor-pointer' onClick={()=>{
                                            //  navigate(`/answer/${id_activity}/${question.id}`)
                                            state.editing = true;
                                            state.reward = reward;
                                            
                                            setState({...state})
                                          
                                        }}>
                                                <MdEdit size={16} color='white'></MdEdit>
                                        </div>


                                        <div className='icon bg-gray cursor-pointer' onClick={()=>{
                                          onDeleteReward(reward.id)
                                        }}>
                                                <MdDelete size={16} color='red'></MdDelete>
                                        </div>
                                      </div>
                                    </td>
                                </tr>
                            )
                        })}
                  
                    </tbody>
            </table>

            </div>
         </div>


        

    </div>

</div>
  )
}
